document.addEventListener('DOMContentLoaded', () => {
    window.initMapAutocomplete = initMapAutocomplete;
    handleLoadMore();
    loadGmaps();
    captureSearchForm();


    const sidebar = document.querySelector('.sidebar-inner');

    if (sidebar) {
        document.addEventListener('facetwp-loaded', setStickyIfFits.bind(null, sidebar));
        document.addEventListener('facetwp-refresh', setStickyIfFits.bind(null, sidebar));
    }

    getScrollbarWidth();

    window.addEventListener('resize', () => {
        getScrollbarWidth();
    });
});

function getScrollbarWidth() {
    document.documentElement.style.setProperty('--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
}

function handleLoadMore() {
    const button = document.body.querySelector('.load-more');
    if (!button) {
        return;
    }
    const IoObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                if (!button?.querySelector(':scope .facetwp-load-more.facetwp-hidden')) {
                    jQuery('.facetwp-load-more').trigger('click');
                }
            }
        }
    }, {
        threshold: 0.1,
        rootMargin: '-150px 0px',
    });
    IoObserver.observe(button);
}

function initMapAutocomplete() {
    const options = {
        componentRestrictions: {country: "nl"},
        fields: ["formatted_address", "geometry", "name"],
        strictBounds: false,
        types: [],
    };
    const autocomplete = new google.maps.places.Autocomplete(document.getElementById('maps-autocomplete'), options);
    window.mapsAutocomplete = autocomplete;
}

function loadGmaps() {
    const keyElement = document.body.querySelector('[data-key]');

    if (!keyElement) {
        return;
    }

    const {key} = keyElement.dataset;
    const strSrc = `//maps.googleapis.com/maps/api/js?libraries=places&callback=initMapAutocomplete&key=${key}`;
    const script = document.createElement('script');
    script.src = strSrc;
    script.type = 'text/javascript'
    script.async = true;

    document.body.appendChild(script);
}

function captureSearchForm() {
    const form = document.querySelector('form.search-bar');
    if (!form) {
        return;
    }

    form.addEventListener('submit', e => {
        e.preventDefault();
        const data = new FormData(e.target);
        const params = new URLSearchParams();
        const place = window.mapsAutocomplete.getPlace();

        if (data.has('_functie')) {
            params.append('_functie', data.get('_functie'));
        }

        if (place && place.geometry && place.geometry.location) {
            console.dir(place);
            params.append('_afstand', [
                place.geometry.location.lat(),
                place.geometry.location.lng(),
                25,
                data.get('_afstand').replace(',', ''),
            ].join(','));
        }

        const targetUrl = new URL(`?${params.toString()}`, e.target.getAttribute('action'));
        window.location = targetUrl.toString();
    });
}

const setStickyIfFits = (sidebar) => {
    const headerHeight = document.querySelector('#header-outer').clientHeight;

    if (sidebar.clientHeight < (window.innerHeight - headerHeight)) {
        sidebar.classList.add('sticky');
    } else {
        sidebar.classList.remove('sticky');
    }
}
